import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const AppLayout = ({ routes, children }) => {
  const location = useLocation();

  useEffect(() => {
    const currentRoute = routes.find((route) => {
      // Handle exact matches and parameterized routes
      if (route.path === location.pathname) return true;

      // For parameterized routes, check if the pattern matches
      const pathParts = route.path.split("/");
      const locationParts = location.pathname.split("/");

      if (pathParts.length !== locationParts.length) return false;

      for (let i = 0; i < pathParts.length; i++) {
        if (pathParts[i].startsWith(":")) continue; // Skip parameters
        if (pathParts[i] !== locationParts[i]) return false;
      }

      return true;
    });

    if (currentRoute) {
      document.title = currentRoute.title || "Default Title";

      // Update meta tags directly
      updateMetaTags({
        title: currentRoute.title || "KBros Leather",
        description:
          currentRoute.description ||
          "High-quality handcrafted leather goods from KBros Leather.",
        keywords:
          currentRoute.keywords ||
          "leather goods, handmade leather, KBros Leather",
      });
    }
  }, [location, routes]);

  // Function to directly update meta tags
  const updateMetaTags = (metaData) => {
    // Update title
    document.title = metaData.title;

    // Update description
    let descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      descriptionTag.setAttribute("content", metaData.description);
    } else {
      descriptionTag = document.createElement("meta");
      descriptionTag.setAttribute("name", "description");
      descriptionTag.setAttribute("content", metaData.description);
      document.head.appendChild(descriptionTag);
    }

    // Update keywords
    let keywordsTag = document.querySelector('meta[name="keywords"]');
    if (keywordsTag) {
      keywordsTag.setAttribute("content", metaData.keywords);
    } else {
      keywordsTag = document.createElement("meta");
      keywordsTag.setAttribute("name", "keywords");
      keywordsTag.setAttribute("content", metaData.keywords);
      document.head.appendChild(keywordsTag);
    }
  };

  return <div>{children}</div>;
};

AppLayout.propTypes = {
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      title: PropTypes.string,
    }),
  ).isRequired,
  children: PropTypes.node.isRequired,
};

export default AppLayout;
